import { render } from "./ElBaseTable.vue?vue&type=template&id=62b8be41"
import script from "./ElBaseTable.vue?vue&type=script&lang=js"
export * from "./ElBaseTable.vue?vue&type=script&lang=js"

import "./ElBaseTable.vue?vue&type=style&index=0&id=62b8be41&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__